import { PaginationTable, TableWrapper } from 'components/Global';
import React, { useEffect, useState } from 'react';
import { ReactComponent as DPFilledIcon } from 'icons/dp-filled-icon.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBusinessRule, getAllBusinessRules } from 'features/business-rules/actions';
import { useAppContext } from 'components/Context/AppContext';
import ActionButtons from 'components/Global/Table/ActionButtons';
import { checkPermission, setCurrency } from 'utils/functionality';
import { resetBusinessRuleSelected } from 'features/business-rules/slice';
import StatusButton from 'components/Global/Table/StatusButton';
import ButtonAdd from 'components/Global/ButtonAdd';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import { format, parseISO } from 'date-fns';
import { trackEvent } from 'utils/analytics';

const column = [
  { header: 'No.', value: 'no' },
  { header: 'Nama', value: 'name' },
  { header: 'Lokasi', value: 'business_rule_location' },
  { header: 'Layanan', value: 'business_rule_subservices' },
  { header: 'Nilai', value: 'rule_threshold' },
  { header: 'Status', value: 'is_applied' },
];

const newColumn = [
  { header: 'No.', value: 'no' },
  { header: 'Nama', value: 'name' },
  { header: 'Lokasi', value: 'business_rule_location' },
  { header: 'Layanan', value: 'business_rule_subservices' },
  { header: 'Nilai', value: 'rule_threshold' },
  { header: 'Tanggal Unavailable', value: 'unavailable_dates' },
  { header: 'Status', value: 'is_applied' },
];

const DownPaymentComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: businessRuleData, status } = useSelector((state) => state.businessRules);
  const { offCanvasMenu, currentMenu } = useSelector((state) => state.menu);

  const { setShowSpinner, setShowConfirmation, showToast } = useAppContext();

  const [currentPage, setCurrentPage] = useState(1);

  const isUnavailableDateEnabled = useFliptBoolean('FLAG_FE_DP_RULES_UNAVAILABLE_DATE', false, 'anonymous');

  useEffect(() => {
    dispatch(getAllBusinessRules({ page: currentPage, type: 'Minimum Down Payment' }));
  }, [currentPage, dispatch]);

  const pageNumber = (page, idx) => (page > 1 ? (page - 1) * 10 + idx : idx);

  const rows = 10 - businessRuleData?.business_rules?.length;

  useEffect(() => {
    if (status == 'loading') {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [status]);

  const onDelete = (e) => {
    const id = e.target.parentElement.parentElement.dataset['key'];
    setShowConfirmation({
      message: 'Apakah anda ingin menghapus data ini?',
      show: true,
      onClick: async () => {
        try {
          trackEvent('business_rule_deleted', { rule_id: id, source: 'down_payment_list' });
          await dispatch(deleteBusinessRule(id)).unwrap();
          showToast({ type: 'success', message: 'Berhasil menghapus setting!' });
          dispatch(getAllBusinessRules({ page: 1, type: 'Minimum Down Payment' }));
          setCurrentPage(1);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
          showToast({ type: 'error', message: 'Gagal menghapus setting!' });
        }
      },
    });
  };

  const onDetail = (e) => {
    const id = e.target.parentElement.parentElement.dataset['key'];
    dispatch(resetBusinessRuleSelected());
    navigate(`/setting-dp/detail?id=${id}`);
  };

  const onAdd = () => {
    dispatch(resetBusinessRuleSelected());
    navigate('/setting-dp/add-item');
  };

  const getFormattedDateString = (dateFrom, dateTo) => {
    let fromString = '';

    const dateFromYear = dateFrom.getFullYear().toString();
    const dateToYear = dateTo.getFullYear().toString();
    const dateFromMonth = dateFrom.getMonth().toString();
    const dateToMonth = dateTo.getMonth().toString();

    if (dateFromMonth === dateToMonth) {
      fromString += 'd';

      if (dateFromYear !== dateToYear) {
        fromString += ' MMM yyyy';
      }
    } else {
      fromString += 'd MMM';

      if (dateFromYear !== dateToYear) {
        fromString += ' yyyy';
      }
    }

    return `${format(dateFrom, fromString)} - ${format(dateTo, 'd MMM yyyy')}`;
  };

  const renderUnavailableDates = (dates) => {
    let parsedDate = [];

    dates?.forEach((date) => {
      if (!Array.isArray(date) || date.length === 0) return;

      const fromDate = parseISO(date[0]);
      const toDate = parseISO(date[date.length - 1]);
      const id = `${date[0]}_${date[date.length - 1]}`;

      parsedDate.push({ id, from: fromDate, to: toDate });
    });

    if (!parsedDate.length) return <div className="schedule-price-unavailable-dates">-</div>;

    return parsedDate.map((item) => (
      <div key={item.id} className="schedule-price-unavailable-dates">
        <div>{getFormattedDateString(item.from, item.to)}</div>
      </div>
    ));
  };

  const usedColumn = isUnavailableDateEnabled ? newColumn : column;

  return (
    <div className="down-payment">
      <ButtonAdd onClick={onAdd} label="Tambah Setting" />

      <TableWrapper icon={<DPFilledIcon fill="#009EF7" width="25px" height="25px" />} title="Setting DP">
        <div className="table">
          <table className="table-wrapper">
            <thead className="table-head">
              <tr>
                {usedColumn.map((item) => (
                  <th key={item.value} style={{ width: item.header === 'Jenis Mobil' ? '240px' : '' }}>
                    {item.header}
                  </th>
                ))}
                <th className="action-col">Action</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {businessRuleData?.business_rules?.length > 0 &&
                businessRuleData?.business_rules?.map((item, no) => (
                  <tr key={item.id}>
                    {usedColumn.map((col) => {
                      if (col.value === 'no') {
                        return (
                          <td
                            key={col.value}
                            data-type="no"
                            className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                          >
                            {pageNumber(currentPage, no + 1)}
                          </td>
                        );
                      } else if (col.value === 'business_rule_location' || col.value === 'business_rule_subservices') {
                        return (
                          <td
                            key={col.value}
                            className={`pre-white-space ${
                              col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''
                            }`}
                            style={{ width: '240px' }}
                          >
                            <div className="schedule-price-locations">
                              {!item[col.value] || item[col.value]?.length === 0 ? (
                                <>-</>
                              ) : (
                                item[col.value].map((li) => (
                                  <div key={li.id}>
                                    <span>{li.name}</span>
                                  </div>
                                ))
                              )}
                            </div>
                          </td>
                        );
                      } else if (col.value === 'rule_threshold') {
                        return (
                          <td
                            key={col.value}
                            data-type={col.value}
                            className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                          >
                            <p>Minimal : {setCurrency(item[col.value].min)}</p>
                            <p>Maksimal : {setCurrency(item[col.value].max)}</p>
                          </td>
                        );
                      } else if (col.value === 'is_applied') {
                        return (
                          <td
                            key={col.value}
                            data-type={col.value}
                            className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                          >
                            <StatusButton status={item[col.value]} />
                          </td>
                        );
                      } else if (col.value === 'unavailable_dates') {
                        return (
                          <td
                            key={col.value}
                            data-type={col.value}
                            className={`pre-white-space ${
                              col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''
                            }`}
                          >
                            <div className="unavailable-dates">{renderUnavailableDates(item[col.value])}</div>
                          </td>
                        );
                      } else {
                        return (
                          <td
                            key={col.value}
                            data-type={col.value}
                            className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                          >
                            {item[col.value]}
                          </td>
                        );
                      }
                    })}
                    <td className="btn-action" data-type="actionButtons" data-key={!item.id ? item.code : item.id}>
                      <ActionButtons
                        del={checkPermission(offCanvasMenu, currentMenu, 'delete') ? onDelete : false}
                        detail={onDetail}
                      />
                    </td>
                  </tr>
                ))}
              {rows > 0 &&
                Array.from({ length: rows }, (_, i) => i + 1).map((row) => (
                  <tr key={row}>
                    {usedColumn.map((item) => (
                      <td key={item.value}></td>
                    ))}
                    <td className="btn-action"></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <PaginationTable
          currentPage={currentPage}
          onPageChange={(newPage) => setCurrentPage(newPage)}
          totalCount={businessRuleData?.Pagination?.total_data}
        />
      </TableWrapper>
    </div>
  );
};

export default DownPaymentComponent;
